export default __webpack_public_path__ + "images/7C.27d848a.png";